import React from 'react'; 
import HeaderNav from '../components/HeaderNav';
import PageIntro from '../components/PageIntro';
import { Link } from 'react-router-dom';

function Contact() {

  const linkedInURL = "https://nz.linkedin.com/company/siso-solutions";
  const emailUser = "info";
  const emailDom = "siso.co.nz";
  const linkText = emailUser + "@" + emailDom; 
  const mailtoLink = `mailto:${linkText}`;

    return (
      <div id="mainContent">
        <div id="navHolder">
          <HeaderNav pageTitle="contact" />
        </div>
        <div id = "intro">
            <h1>Contact Us</h1>
            <PageIntro pageTitle="Contact" output="intro"/>
        </div>
        <div className="contactContent">
            <div className="contactText">
            <div id="contact_address">
						  <h2>LOCATION</h2>
						  <p>Based in Wellington, NZ but happy to work remote.<br />
                Have worked with clients in US, UK, Australia, Switzerland and beyond.</p>
            </div>
					<div id="contact_email">
						<h2>EMAIL</h2>
						<a href={mailtoLink} id="emailLink">
        {linkText}
      </a>
					</div>
					<div id="contact_social">
						<h2>SOCIAL</h2>
				<div id="contact_linkedin">
							<Link to={linkedInURL} reloadDocument className="contactLink" id="contact_linkedin" >
								<svg version="1.1" className="contact_svg" id="linkedin_svg" role="img" aria-labelledby="lITitle lIDesc"x="0px" y="0px"
	 width="96px" height="80px" viewBox="0 0 96 80" preserveAspectRatio="xMidYMid">
	 <title id = "lITitle">LinkedIn Logo</title>
	 <desc id = "lIDesc">Link to visit the Siso LinkedIn page</desc>
<path fill="none" stroke="#010202" stroke-width="2" stroke-miterlimit="10" d="M25.727,11.442c0,4.382-3.523,7.933-7.87,7.933
	c-4.348,0-7.871-3.551-7.871-7.933c0-4.378,3.523-7.933,7.871-7.933C22.203,3.51,25.727,7.064,25.727,11.442z M25.789,25.721H9.924
	v50.769h15.865V25.721z M51.117,25.721H35.352v50.769h15.766V49.841c0-14.817,19.131-16.032,19.131,0v26.648h15.828V44.344
	c0-25.003-28.31-24.095-34.959-11.784V25.721z"/>
</svg>
							</Link>
						</div>
            </div>
            </div>
        </div>
      </div>
    );
  }
export default Contact;
